var _excluded = ["onChange", "isChecked", "title", "hasError", "isHighlighted", "isRequired", "isDisabled", "hasExpandedClickField"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import { cover, rgba } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var StarSvg = function StarSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.852 4.468 0 3.618.434 2.19l2.853 1.06L3.202 0h1.445l-.094 3.296 2.805-1.039.434 1.436-2.9.86 1.87 2.56L5.593 8 3.835 5.28l-1.7 2.654-1.181-.86 1.898-2.606z"
  }));
};
StarSvg.defaultProps = {
  width: "8",
  height: "8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TickSvg = function TickSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 1.33 5.057 10 0 5.098l1.374-1.33 3.684 3.57L12.626 0 14 1.33z"
  }));
};
TickSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
};
import { lowEmphasisOpacity } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import setClickableArea from "../../../utils/setClickableArea";
import space, { spaceFactor } from "../../../utils/space";
import unit from "../../../utils/unit";
export var checkboxSizeSpace = 2.5;
var clickableFieldSizeSpace = 4;
var arrowWidth = 14;
var arrowHeight = 10;
var Container = styled.div.withConfig({
  componentId: "sc-1c2er47-0"
})(["display:flex;position:relative;flex-shrink:0;width:", ";height:", ";"], space(checkboxSizeSpace), space(checkboxSizeSpace));

/*
 * 1. Styles needed to overwrite old CSS
 * */
var StyledInput = styled.input.withConfig({
  componentId: "sc-1c2er47-1"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    $hasError = _ref.$hasError,
    $isHighlighted = _ref.$isHighlighted,
    $isDisabled = _ref.$isDisabled,
    $hasExpandedClickField = _ref.$hasExpandedClickField,
    theme = _ref.theme;
  return css(["position:static;width:100%;height:100%;margin:0;border:", " solid ", ";appearance:none;border-radius:", ";cursor:pointer;&:hover{border-color:", ";}&:checked{border-color:", ";background-color:", ";&:hover{opacity:0.8;}}", " ", " ", " ", " ", ""], unit(2), getBorderColor(theme, $onColor, "high"), getBorderRadius(theme, "small"), getBorderColor(theme, $onColor, "high", "hover"), getColor(theme, "success"), getColor(theme, "success"), setClickableArea(clickableFieldSizeSpace), $hasError && css(["border-color:", ";"], rgba(getColor(theme, "error"), lowEmphasisOpacity)), $isHighlighted && css(["border-color:", ";"], getColor(theme, "success")), $isDisabled && css(["border-color:", " !important;cursor:not-allowed;&:checked{background-color:", ";&:hover{opacity:1;}}"], getColor(theme, "disabled"), getColor(theme, "disabled")), $hasExpandedClickField && css(["&::before{", ";content:\"\";}"], cover()));
});
var Tick = styled(TickSvg).withConfig({
  componentId: "sc-1c2er47-2"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["position:absolute;transform:translate( ", ",", " );fill:", ";pointer-events:none;", "{width:", ";}"], unit((spaceFactor * checkboxSizeSpace - arrowWidth) / 2), unit((spaceFactor * checkboxSizeSpace - arrowHeight) / 2), getColor(theme, $onColor), breakpoint("small", "medium"), unit(12));
});
var Star = styled(StarSvg).withConfig({
  componentId: "sc-1c2er47-3"
})(function (_ref3) {
  var $isChecked = _ref3.$isChecked,
    $hasError = _ref3.$hasError,
    $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["position:absolute;transform:translateX(", ");fill:", ";pointer-events:none;", " ", ""], space(checkboxSizeSpace + 0.5), getIconColor(theme, $onColor, "high"), $isChecked && css(["fill:", ";"], getColor(theme, "success")), $hasError && css(["fill:", ";"], getColor(theme, "error")));
});
function CheckboxAtm(_ref4) {
  var onChange = _ref4.onChange,
    isChecked = _ref4.isChecked,
    title = _ref4.title,
    hasError = _ref4.hasError,
    isHighlighted = _ref4.isHighlighted,
    isRequired = _ref4.isRequired,
    isDisabled = _ref4.isDisabled,
    hasExpandedClickField = _ref4.hasExpandedClickField,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(StyledInput, _extends({
    checked: isChecked,
    disabled: isDisabled,
    onChange: onChange,
    title: title,
    type: "checkbox",
    $isDisabled: isDisabled,
    $isHighlighted: !!isHighlighted,
    $hasError: !!hasError,
    $hasExpandedClickField: !!hasExpandedClickField,
    $onColor: onColor
  }, restProps)), /*#__PURE__*/React.createElement(Tick, {
    $onColor: onColor
  }), isRequired ? /*#__PURE__*/React.createElement(Star, {
    $isChecked: isChecked,
    $hasError: !!hasError,
    $onColor: onColor
  }) : null);
}
export default CheckboxAtm;